"use client";

import { useCallback, useEffect, useRef, useState } from "react";
import styles from "./doce_lembranca88.module.scss";
import Logo from "./images/logo.png";
import Cesta1 from "./images/cestas/cesta1.png";
import Cesta2 from "./images/cestas/cesta2.png";
import Cesta3 from "./images/cestas/cesta3.png";
import Cesta4 from "./images/cestas/cesta4.png";
import Cesta5 from "./images/cestas/cesta5.png";
import Cesta6 from "./images/cestas/cesta6.png";
import Cesta7 from "./images/cestas/cesta7.png";
import Cesta8 from "./images/cestas/cesta8.png";
import Cesta9 from "./images/cestas/cesta9.png";

/**
 * ==== CONFIGURAÇÃO ====
 * Ajuste os links e imagens abaixo conforme os dados reais da loja.
 */
const INSTAGRAM_URL =
    "https://www.instagram.com/doce_lembranca88?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==";

// Troque pelo link real de pedido (WhatsApp, formulário, etc.)
const ORDER_MSG = "Olá! Vim pelo link na bio e gostaria de mais informações.";
const ORDER_URL = `https://wa.me/5517991063217?text=${encodeURIComponent(ORDER_MSG)}`;

type CestaItem = {
    id: string;
    src: string;
    alt: string;
    tag: string;
    title: string;
};

const CESTAS: CestaItem[] = [
    {
        id: "super-pai",
        src: Cesta1,
        alt: "Caixote de madeira 'Com Carinho' com caneca Super Pai, balão azul Feliz Dia dos Pais e petiscos como Bis, Club Social e achocolatado",
        tag: "Dia dos Pais",
        title: "Eu tenho um Super Pai",
    },
    {
        id: "corinthians",
        src: Cesta2,
        alt: "Caixa preta com laço azul, copo térmico do Corinthians, balão Feliz Dia dos Pais e snacks como Ruffles, Takis, Oreo e Bis",
        tag: "Dia dos Pais",
        title: "Cesta Timão",
    },
    {
        id: "melhor-pai-do-mundo",
        src: Cesta3,
        alt: "Caixa preta com laço vermelho e texto Melhor Pai do Mundo, balão de coração preto, Pringles, Coca-Cola e chocolates",
        tag: "Dia dos Pais",
        title: "Melhor Pai do Mundo",
    },
    {
        id: "corona-pais",
        src: Cesta4,
        alt: "Caixa preta com laço verde, cerveja Corona Extra, taça personalizada Feliz Dia dos Pais, potinho de amendoim e Ferrero Rocher",
        tag: "Dia dos Pais",
        title: "Feliz Dia dos Pais",
    },
    {
        id: "corinthians-brinde",
        src: Cesta5,
        alt: "Caixa branca com adesivo do Corinthians, balão de coração preto Te amo Pai, cerveja Corona, Lay's Sensações e potinho de petiscos",
        tag: "Dia dos Pais",
        title: "Um Brinde ao Melhor Pai",
    },
    {
        id: "caneca-melhor-pai",
        src: Cesta6,
        alt: "Caneca branca Uso Exclusivo do melhor Pai do Mundo com balão de coração azul, Trento, Pão de Mel Bauducco e cappuccino",
        tag: "Dia dos Pais",
        title: "Uso Exclusivo do Melhor Pai",
    },
    {
        id: "deus-escolheu-pai",
        src: Cesta7,
        alt: "Caixa preta Com Carinho com caneca azul personalizada, balão azul Feliz Dia dos Pais, bolinhos Bauducco e laço branco",
        tag: "Dia dos Pais",
        title: "Deus Escolheu o Melhor Pai",
    },
    {
        id: "citrus-pais",
        src: Cesta8,
        alt: "Caixa branca com laço verde, balão estrela verde, Schweppes Citrus, Crocantíssimo, amendoim Dori e chocolate",
        tag: "Dia dos Pais",
        title: "Cesta Citrus",
    },
    {
        id: "com-carinho-flork",
        src: Cesta9,
        alt: "Caixote de madeira Com Carinho com caneca Flork, balão de coração rose gold, cappuccino Itambé, KitKat e snacks Bauducco",
        tag: "Com Carinho",
        title: "Cesta Flork",
    },
];

const AUTOPLAY_DELAY = 5000;

export default function DoceLembranca88() {
    const [index, setIndex] = useState(0);
    const [isPaused, setIsPaused] = useState(false);
    const touchStartX = useRef<number | null>(null);
    const total = CESTAS.length;

    const goTo = useCallback(
        (i: number) => {
            setIndex(((i % total) + total) % total);
        },
        [total]
    );

    const next = useCallback(() => goTo(index + 1), [goTo, index]);
    const prev = useCallback(() => goTo(index - 1), [goTo, index]);

    useEffect(() => {
        if (isPaused) return;
        const timer = setInterval(() => {
            setIndex((i) => (i + 1) % total);
        }, AUTOPLAY_DELAY);
        return () => clearInterval(timer);
    }, [isPaused, total]);

    const handleTouchStart = (e: React.TouchEvent) => {
        touchStartX.current = e.touches[0].clientX;
        setIsPaused(true);
    };

    const handleTouchEnd = (e: React.TouchEvent) => {
        if (touchStartX.current === null) return;
        const delta = e.changedTouches[0].clientX - touchStartX.current;
        if (delta > 40) prev();
        else if (delta < -40) next();
        touchStartX.current = null;
        setIsPaused(false);
    };

    return (
        <div className={styles.doce_lembranca88}>
            <div className={styles.page}>
                <div className={styles.hero}>
                    <div className={styles.logoRing}>
                        <img
                            src={Logo}
                            alt="Doce Lembrança - Cestas de Presente & Afeto"
                            className={styles.logoImg}
                        />
                    </div>

                    <h1 className={styles.brandName}>Doce Lembrança</h1>

                    <p className={styles.tagline}>
                        <span className={styles.taglineRule} aria-hidden="true" />
                        Cestas de Presente &amp; Afeto
                        <span className={styles.taglineRule} aria-hidden="true" />
                    </p>

                    <div className={styles.actions}>
                        <a
                            href={ORDER_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`${styles.btn} ${styles.btnPrimary}`}
                        >
                            <svg
                                className={styles.btnIcon}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" />
                                <path d="M3 6h18" />
                                <path d="M16 10a4 4 0 0 1-8 0" />
                            </svg>
                            Faça seu pedido
                        </a>

                        <a
                            href={INSTAGRAM_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`${styles.btn} ${styles.btnSecondary}`}
                        >
                            <svg
                                className={styles.btnIcon}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <rect x="3" y="3" width="18" height="18" rx="5" />
                                <circle cx="12" cy="12" r="4" />
                                <circle cx="17.2" cy="6.8" r="0.6" fill="currentColor" stroke="none" />
                            </svg>
                            Instagram
                        </a>
                    </div>
                </div>

                <div className={styles.section} aria-label="Cestas personalizadas">
                    <div className={styles.sectionHead}>
                        <span className={styles.eyebrow}>Nossas criações</span>
                        <h2 className={styles.sectionTitle}>Cestas em destaque</h2>
                    </div>

                    <div
                        className={styles.carousel}
                        onMouseEnter={() => setIsPaused(true)}
                        onMouseLeave={() => setIsPaused(false)}
                    >
                        <div
                            className={styles.carouselViewport}
                            onTouchStart={handleTouchStart}
                            onTouchEnd={handleTouchEnd}
                        >
                            <div
                                className={styles.track}
                                style={{ transform: `translateX(-${index * 100}%)` }}
                                role="group"
                                aria-roledescription="carrossel"
                                aria-label="Cestas personalizadas"
                            >
                                {CESTAS.map((cesta, i) => (
                                    <div
                                        className={styles.slide}
                                        key={cesta.id}
                                        role="group"
                                        aria-roledescription="slide"
                                        aria-label={`${i + 1} de ${total}`}
                                        aria-hidden={i !== index}
                                    >
                                        <img
                                            src={cesta.src}
                                            alt={cesta.alt}
                                            className={styles.slideImg}
                                        />
                                        <div className={styles.slideOverlay}>
                                            <span className={styles.slideTag}>{cesta.tag}</span>
                                            <p className={styles.slideTitle}>{cesta.title}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <button
                            type="button"
                            className={`${styles.navBtn} ${styles.navPrev}`}
                            onClick={prev}
                            aria-label="Cesta anterior"
                        >
                            <svg
                                className={styles.navIcon}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path d="M15 18l-6-6 6-6" />
                            </svg>
                        </button>

                        <button
                            type="button"
                            className={`${styles.navBtn} ${styles.navNext}`}
                            onClick={next}
                            aria-label="Próxima cesta"
                        >
                            <svg
                                className={styles.navIcon}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path d="M9 18l6-6-6-6" />
                            </svg>
                        </button>
                    </div>

                    <div className={styles.dots}>
                        {CESTAS.map((cesta, i) => (
                            <button
                                key={cesta.id}
                                type="button"
                                className={`${styles.dot} ${i === index ? styles.dotActive : ""}`}
                                onClick={() => goTo(i)}
                                aria-label={`Ir para a cesta ${i + 1}`}
                                aria-current={i === index}
                            />
                        ))}
                    </div>
                </div>

                <div className={styles.footer}>
                    <svg
                        className={styles.footerHeart}
                        viewBox="0 0 24 24"
                        fill="currentColor"
                    >
                        <path d="M12 21s-7.5-4.6-10-9.1C.4 8.6 2 5 5.6 5c2 0 3.4 1 4.4 2.6C11 6 12.4 5 14.4 5 18 5 19.6 8.6 22 11.9 19.5 16.4 12 21 12 21Z" />
                    </svg>
                    <p className={styles.footerText}>feito com carinho, para o seu presente</p>
                </div>
            </div>
        </div>
    );
}
